import React from 'react';

import { ActivitySectionLayout } from 'modules/components/layer32';
import { PlanTable } from 'modules/components/layer25';

export type PlansDetailSectionProps = {
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PlansDetailSectionProps) => {

  return (
    <ActivitySectionLayout.FC>
      <PlanTable.FC />
    </ActivitySectionLayout.FC>

  );
};
